import { createAction } from 'skybase-ui/skybase-core/base/create-action'

import { getActionName } from './utils'

export const INITIALIZE_APP = getActionName('INITIALIZE_APP')
export const initializeApp = () => createAction(INITIALIZE_APP)
